import actions from './modules/actions/actions'
import actionsStats from './modules/actions/actionsStats'
import alerts from './modules/alerts/alerts'
import application from './modules/problemResolution/application'
import auditStats from './modules/stats/audits'
import comments from './modules/comments/comments'
import communications from './modules/communications'
import configuration from './modules/configuration/configuration'
import dailyroundCheckpoints from './modules/taskManager/dailyroundCheckpoints'
import diagnosis from './modules/diagnosis/diagnosis'
import gembaWalk from './modules/gembaWalk/checkPoints'
import hse from './modules/hse/hse'
import ilu from './modules/ilu/ilu'
import iluCharts from './modules/ilu/charts'
import improvementIdea from './modules/improvementIdea/improvementIdea'
import lpas from './modules/lpa/lpas'
import myCalendar from './modules/myCalendar/calendar'
import okFirstPart from './modules/okFirstPart/okFirstPart'
import pendingItems from './modules/core/pendingItems'
import people from './modules/people/people'
import perimeters from './modules/perimeters/perimeters'
import pmm from './modules/integration/pmm'
import problems from './modules/problemResolution/problems'
import problemsCharts from './modules/problemResolution/charts'
import productionHierarchy from './modules/organization/productionHierarchy'
import products from './modules/organization/products'
import profile from './modules/people/profile'
import reports from 'frontend/store/modules/reports/reports'
import sections from './modules/sections/sections'
import selections from './modules/core/selections'
import settings from './modules/settings/settings'
import shifts from './modules/shifts/shifts'
import standardAbilityCertifications from "./modules/standards/standardAbilityCertifications"
import standardErgonomicsLevels from './modules/standards/standardErgonomicsLevels'
import standardProductionConfigurations from './modules/standards/standardProductionConfigurations'
import standards from './modules/standards/standards'
import standardWorkReview from './modules/standardWorkReview/standardWorkReview'
import stats from './modules/stats/stats'
import structure from './modules/perimeters/factoryStructure'
import taskManager from './modules/taskManager/taskManager'
import templates from './modules/templates/templates'
import virtualTrainingStats from './modules/stats/virtualTraining'
import { createStore } from 'vuex'

export const store = createStore({
  modules: {
    actions,
    actionsStats,
    alerts,
    application,
    auditStats,
    comments,
    communications,
    configuration,
    dailyroundCheckpoints,
    diagnosis,
    gembaWalk,
    hse,
    ilu,
    iluCharts,
    improvementIdea,
    lpas,
    myCalendar,
    okFirstPart,
    pendingItems,
    people,
    perimeters,
    pmm,
    problems,
    problemsCharts,
    productionHierarchy,
    products,
    profile,
    sections,
    selections,
    settings,
    shifts,
    standardAbilityCertifications,
    standardErgonomicsLevels,
    standardProductionConfigurations,
    standardWorkReview,
    standards,
    stats,
    structure,
    taskManager,
    templates,
    virtualTrainingStats,
    reports,
  },
})
